import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PanelPage from "../../components/panel/panelPage";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelSearch from "../../components/filters/panelSearch";
import GroupListTable from "../../components/users/groupListTable";
import { closeModal, openModal } from "../../state/modalSlice";
import CreateGroupModal from "../../modals/group/createGroup";
import { actions } from "../../state/reducer";
import { generateRandomString } from "../../utils";

const GroupListPage = () => {

  const [searchValue, setSearchValue] = useState("")
  const dispatch = useDispatch()
  const search = (value: string) => {
    console.log(value)
    setSearchValue(value);
  }

  const handleOpenCreateModal = () => {
    dispatch(
      openModal({
        component: CreateGroupModal,
        context: {
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="Группы" />
            <div className="panelBtnContainer">
              <div className="btn panelActionBtn" onClick={handleOpenCreateModal}>+ Создать группу</div>
            </div>
          </div>
          <div className="flex between panelSearchContainer">
             <PanelSearch hint={"Поиск по названию"} onChange={search} />
          </div>
          <GroupListTable search={searchValue} />
        </div>
      </div>
    </PanelPage>
  );
};

export default GroupListPage;
